export default __webpack_public_path__ + "static/media/sneak.eb1c9ebe.png";